export function handleError(e) {
    if (e === "cancel") {
        return
    } else {
        console.log(e);
    }
}